import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableUpsTerms2 = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableUpsTerms2);
};
